const offlinePaymentMethods = [
  "cash",
  "kod",
  "benefit-transfer",
  "pos",
  "payment days",
  "on-credit",
  "wallet",
  "wallet,cash",
  "cash,wallet",
  "wallet,kod",
  "kod,wallet",
  "wallet,benefit-transfer",
  "loyalty points",
  "loyalty points,cash",
  "cash,loyalty points",
  "loyalty points,kod",
  "kod,loyalty points",
  "loyalty points,benefit-transfer",
];

export { offlinePaymentMethods };
